
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 28 28","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.5 11.667c-.644 0-1.167.522-1.167 1.166v9.334a3.5 3.5 0 003.5 3.5h16.334a3.5 3.5 0 003.5-3.5v-9.334c0-.644-.523-1.166-1.167-1.166h-21zm14.342 8.175a1.167 1.167 0 001.65 1.65l2-2a1.167 1.167 0 000-1.65l-2-2a1.166 1.166 0 10-1.65 1.65l1.175 1.174-1.175 1.176zm-7.684 1.65a1.167 1.167 0 000-1.65l-1.175-1.175 1.175-1.175a1.167 1.167 0 00-1.65-1.65l-2 2a1.167 1.167 0 000 1.65l2 2a1.167 1.167 0 001.65 0zm3.72-6.646a1.167 1.167 0 012.244.641l-2 7a1.166 1.166 0 11-2.244-.64l2-7zM5.833 2.333a3.5 3.5 0 00-3.5 3.5v2.334c0 .644.523 1.166 1.167 1.166h21c.644 0 1.167-.522 1.167-1.166V5.833a3.5 3.5 0 00-3.5-3.5H5.833zm0 4.667a1.167 1.167 0 100-2.333 1.167 1.167 0 000 2.333zM10.5 5.833a1.167 1.167 0 11-2.333 0 1.167 1.167 0 012.333 0zM12.833 7a1.167 1.167 0 100-2.333 1.167 1.167 0 000 2.333z"}})])
          )
        }
      }
    